var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-permission-settings" },
    [
      _c("div", { staticClass: "mode-switch-section" }, [
        _c("div", { staticClass: "mode-label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v(_vm._s(_vm.permissionMode === "public" ? "public" : "lock")),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "mode-title" }, [
            _vm._v(_vm._s(_vm.$t("automation.permissions.mode"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-switch" },
          [
            _c(
              "a-switch",
              {
                attrs: { disabled: _vm.saving },
                on: { change: _vm.onModeChange },
                model: {
                  value: _vm.isCustomMode,
                  callback: function ($$v) {
                    _vm.isCustomMode = $$v
                  },
                  expression: "isCustomMode",
                },
              },
              [
                _c(
                  "span",
                  {
                    attrs: { slot: "checkedChildren" },
                    slot: "checkedChildren",
                  },
                  [_vm._v(_vm._s(_vm.$t("automation.permissions.customMode")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    attrs: { slot: "unCheckedChildren" },
                    slot: "unCheckedChildren",
                  },
                  [_vm._v(_vm._s(_vm.$t("automation.permissions.publicMode")))]
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mode-description" }, [
          _vm.permissionMode === "public"
            ? _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("automation.permissions.publicModeDesc")) +
                    "\n            "
                ),
              ])
            : _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("automation.permissions.customModeDesc")) +
                    "\n            "
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.permissionMode === "custom"
        ? _c(
            "div",
            { staticClass: "custom-permissions" },
            [
              _c(
                "a-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "users",
                      attrs: { tab: _vm.$t("automation.permissions.usersTab") },
                    },
                    [
                      _c("AutomationUserPermissionsTab", {
                        attrs: {
                          users: _vm.users,
                          departments: _vm.departments,
                          "permission-targets": _vm.permissionTargets,
                          "scope-groups": _vm.scopeGroups,
                          "current-user-id": _vm.currentUserId,
                        },
                        on: {
                          "toggle-scope": _vm.onToggleScope,
                          "activate-target": _vm.onActivateTarget,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    {
                      key: "departments",
                      attrs: {
                        tab: _vm.$t("automation.permissions.departmentsTab"),
                      },
                    },
                    [
                      _c("AutomationDepartmentPermissionsTab", {
                        attrs: {
                          departments: _vm.departments,
                          users: _vm.users,
                          "permission-targets": _vm.permissionTargets,
                          "scope-groups": _vm.scopeGroups,
                        },
                        on: {
                          "toggle-scope": _vm.onToggleScope,
                          "activate-target": _vm.onActivateTarget,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-footer" },
        [
          _c(
            "SupsisButton",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content: _vm.$t("automation.permissions.applyToOthersDesc"),
                  },
                  expression:
                    "{ content: $t('automation.permissions.applyToOthersDesc') }",
                },
              ],
              attrs: { ghost: "", disabled: _vm.saving },
              on: { click: _vm.openApplyToOthersModal },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("content_copy"),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("automation.permissions.applyToOthers")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { disabled: _vm.saving },
                  on: { click: _vm.onCancel },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("common.cancel")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { primary: "", loading: _vm.saving },
                  on: { click: _vm.onSave },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("common.save")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("automation.permissions.applyToOthersTitle"),
            width: 700,
            footer: null,
            maskClosable: false,
          },
          model: {
            value: _vm.applyToOthersModalVisible,
            callback: function ($$v) {
              _vm.applyToOthersModalVisible = $$v
            },
            expression: "applyToOthersModalVisible",
          },
        },
        [
          _c("div", { staticClass: "apply-to-others-modal" }, [
            _c(
              "div",
              { staticClass: "modal-description" },
              [
                _c("a-alert", {
                  attrs: {
                    message: _vm.$t(
                      "automation.permissions.applyToOthersWarning"
                    ),
                    type: "warning",
                    "show-icon": "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "search-section" },
              [
                _c("a-input-search", {
                  staticClass: "search-input",
                  attrs: {
                    placeholder: _vm.$t(
                      "automation.permissions.searchPlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.applySearchText,
                    callback: function ($$v) {
                      _vm.applySearchText = $$v
                    },
                    expression: "applySearchText",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "automation-list-section" }, [
              _c(
                "div",
                { staticClass: "list-header" },
                [
                  _c(
                    "a-checkbox",
                    {
                      attrs: {
                        checked: _vm.isAllSelected,
                        indeterminate: _vm.isIndeterminate,
                      },
                      on: { change: _vm.toggleSelectAll },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("automation.permissions.selectAll")) +
                          " (" +
                          _vm._s(_vm.filteredOtherAutomations.length) +
                          ")\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "automation-list" },
                [
                  _vm._l(
                    _vm.categorizedOtherAutomations,
                    function (category, categoryName) {
                      return [
                        _c(
                          "div",
                          {
                            key: "cat-" + categoryName,
                            staticClass: "category-header",
                            on: {
                              click: function ($event) {
                                return _vm.toggleCategorySelection(categoryName)
                              },
                            },
                          },
                          [
                            _c("a-checkbox", {
                              attrs: {
                                checked: _vm.isCategorySelected(categoryName),
                                indeterminate:
                                  _vm.isCategoryIndeterminate(categoryName),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                                change: function ($event) {
                                  return _vm.toggleCategorySelection(
                                    categoryName
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("folder"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "category-name" }, [
                              _vm._v(_vm._s(categoryName)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "category-count" }, [
                              _vm._v("(" + _vm._s(category.length) + ")"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(category, function (auto) {
                          return _c(
                            "div",
                            {
                              key: auto._id,
                              staticClass: "automation-item",
                              class: {
                                selected: _vm.selectedAutomationIds.includes(
                                  auto._id
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleAutomationSelection(auto._id)
                                },
                              },
                            },
                            [
                              _c("a-checkbox", {
                                attrs: {
                                  checked: _vm.selectedAutomationIds.includes(
                                    auto._id
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "automation-info" }, [
                                _c("span", { staticClass: "automation-name" }, [
                                  _vm._v(_vm._s(auto.name)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "automation-status" },
                                [
                                  auto.published
                                    ? _c(
                                        "a-tag",
                                        {
                                          attrs: {
                                            color: "green",
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("automation.published")
                                            )
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "a-tag",
                                        {
                                          attrs: {
                                            color: "default",
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("automation.unpublished")
                                            )
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _vm.filteredOtherAutomations.length === 0
                    ? _c("div", { staticClass: "empty-list" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("search_off"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "automation.permissions.noAutomationsFound"
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("span", { staticClass: "selected-count" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("automation.permissions.selectedCount", {
                        count: _vm.selectedAutomationIds.length,
                      })
                    ) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-buttons" },
                [
                  _c(
                    "SupsisButton",
                    { on: { click: _vm.closeApplyToOthersModal } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("common.cancel")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        primary: "",
                        loading: _vm.applyingToOthers,
                        disabled: _vm.selectedAutomationIds.length === 0,
                      },
                      on: { click: _vm.applyToSelectedAutomations },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("automation.permissions.applyToSelected")
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }